<template>
  <header
    class="header-legacy"
    :class="[{ 'header-legacy--themed': !!themeColor }, themeColor]"
  >
    <T3Link
      class="header-legacy__logo"
      :to="homeLink"
      :aria-label="translation.goHome"
    >
      <Logo />
    </T3Link>

    <div class="header-legacy__navigation header-legacy__navigation--desktop">
      <slot name="desktop" />
    </div>

    <div class="header-legacy__navigation header-legacy__navigation--mobile">
      <slot name="mobile" />
    </div>
  </header>
</template>

<script setup lang="ts">
import type { BaseHeaderProps } from '~ui/types'

defineProps<BaseHeaderProps>()
</script>

<style lang="scss">
$header-h: rem(100px);

:root.legacy {
  --content-offset: #{$header-h};
}

.header-legacy {
  position: sticky;
  top: 0;
  z-index: z-index(header);
  height: var(--content-offset);
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: range-clamp(8px, 64px, 1100px, 1400px);
  color: color(black);
  background-color: color(white);
  margin-inline: auto;
  transition: background-color 0.2s;

  @include frame-content-container(large);

  --border-color: #d0d6de;
  --border-color-active: #6e7277;
  --shadow-color: #{rgba(color(black), 20%)};

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: z-index(header);
    pointer-events: none;
    background-color: transparent;
    box-shadow: 1px 1px 3px var(--shadow-color);
  }

  &--themed {
    --border-color: #839da9;
    --border-color-active: #abc2cd;
    --shadow-color: #{rgba(color(white), 8%)};

    color: var(--theme__font-color, color(black));
    background-color: var(--theme__theme-color, color(white));
  }

  & > &__logo:is(a) {
    color: inherit;
  }

  &__navigation {
    --bg-100: #faf9fa;
    --bg-200: #eff1f3;

    --font-100: #727b89;
    --font-200: #414a58;
    --font-300: #434a5b;

    &--desktop {
      display: flex;
      flex-grow: 1;
      height: 100%;

      @include media-query(max md) {
        display: none;
      }
    }

    &--mobile {
      display: block;
      margin-left: auto;

      @include media-query(md) {
        display: none;
      }
    }
  }
}
</style>
